import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../../../../../../language/keys';
import ExplainabilityWidgetItem from '../../explainability-widget-item.component';
import { LanguageIcon } from './explainability-widget-language.styled';

const ExplainabilityWidgetLanguage = ({ languages }: ExplainabilityWidgetLanguageProps): JSX.Element | null => {
  const { t: translate } = useTranslation();

  if (!languages.length) {
    return null;
  }

  return (
    <ExplainabilityWidgetItem
      key="ExplainabilityWidgetLanguage"
      label={ translate(STRING_KEYS.MATCH_CARD.EXPLAINABILITY_WIDGET.ITEMS_LABELS.LANGUAGES) }
      value={ `${languages.join(', ')}` }
      Icon={ LanguageIcon }
    />
  );
};

export default ExplainabilityWidgetLanguage;
